import './testimonials.scss'
import { ImProfile } from "react-icons/im";

export const Testimonials = () => {
  return (
    <div className="Main" id="testimonials">
      <h2>About Me.</h2>
      <div className="testimonials" >
        <div className="left">
          <div className="textContainer">
            <h1>Hello, I’m Akash Borate !</h1>
            <h2>A highly motivated full stack web developer, who love building new things,
              products and websites to solve everyday problems. I am empathetic, approachable and an active listener;
                traits that allow me to create great projects and build relationships along the way.
            </h2>
            <a href="https://drive.google.com/file/d/1Lj4-bu4qtUiihHZyW6-UB31_jCE5peNL/view?usp=sharing" target="_blank" rel='noreferrer'><button><h2><ImProfile/> Resume</h2></button></a>
          </div>
        </div>
        <div className="right">
            <div className="imgContainer">
              <img src="https://miro.medium.com/max/1400/1*UFK4FjRiapOJ44dwksBanw.gif" alt="" />
            </div>
        </div>
      </div>
    </div>
  )
}

